import SHIPPING_METHODS from '../../../constants/ShippingMethods';
import { IShippingMethod } from '../../../domain/entities/ShippingMethodsCollection/ShippingMethodsCollection';
import { IShipOption } from '../../IApiResponses';

const shipOptionsMapper = {
  response(shipOptions: IShipOption[]): IShippingMethod[] {
    return shipOptions.map(item => ({
      discount: item.discount,
      estimatedDeliveryEndDate: item.estimated_delivery_end_date,
      estimatedDeliveryStartDate: item.estimated_delivery_start_date,
      id: item.ship_method_id as SHIPPING_METHODS,
      name: item.name,
      nextAvailableSat: item.next_available_sat,
      price: item.price,
      skuId: item.sku_base_id,
      sortOrder: item.sort_order,
      totalPrice: item.discount ? item.price + item.discount : item.price,
    }));
  },
};

export default shipOptionsMapper;
